import { Check, X, IndianRupee } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { Avatar } from "@/components/PersonCard";
import { formatINR, useNetWorth } from "@/context/NetWorthContext";
import { t } from "@/lib/i18n";
import { toast } from "sonner";

export const NetWorthRequestCard = ({ n, user, onAction }) => {
  const { reload } = useNetWorth();
  const act = async (kind) => {
    try {
      const { data } = await api.post(`/networth-requests/${n.request_id}/${kind}`);
      toast.success(kind === "reject" ? t("Entry rejected") : data.status === "pending" ? `${t("Approval recorded")} (${data.approvals}/${data.needed})` : t("Net worth saved"));
      reload();
      onAction();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const canApprove = user.can_vote && (user.is_admin || (!n.mine && !n.i_approved));
  return (
    <div className="rounded-3xl border border-[#C59B27]/40 bg-white p-6 flex flex-col md:flex-row gap-5 md:items-center" data-testid={`networth-card-${n.request_id}`}>
      <Avatar p={{ name: n.person_name, photo_url: n.photo_url, gender: n.gender }} size="w-14 h-14 text-lg shrink-0" />
      <div className="flex-1 min-w-0 space-y-1">
        <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#8A6A12] flex items-center gap-1"><IndianRupee className="w-3 h-3" />{t("Net worth")} · {t("by")} {n.submitted_by}</p>
        <p className="font-serif text-xl font-semibold">{n.person_name}: {formatINR(n.amount)}</p>
        {n.current_amount !== null && <p className="text-xs text-[#7E8E85]">{t("Currently")}: {formatINR(n.current_amount)}</p>}
        {n.details && <p className="text-sm text-[#52635B] whitespace-pre-line">{n.details}</p>}
      </div>
      <div className="md:w-56 space-y-2">
        <p className="text-sm font-medium" data-testid={`networth-approvals-${n.request_id}`}>{n.approvals}/{n.needed} {t("approvals")}</p>
        {n.i_approved && <p className="text-xs text-[#2E7D32]">{t("You approved this")}</p>}
        <div className="flex gap-2">
          {canApprove && <Button size="sm" onClick={() => act("approve")} className="rounded-full bg-[#1E3A2B] hover:bg-[#162C20]" data-testid={`networth-approve-btn-${n.request_id}`}><Check className="w-4 h-4 mr-1" />{t("Approve")}</Button>}
          {n.mine && !user.is_admin && <span className="text-xs text-[#7E8E85] self-center">{t("Needs 3 approvals")}</span>}
          {user.is_admin && <Button size="sm" variant="outline" onClick={() => act("reject")} className="rounded-full text-[#C62828]" data-testid={`networth-reject-btn-${n.request_id}`}><X className="w-4 h-4 mr-1" />{t("Reject")}</Button>}
        </div>
      </div>
    </div>
  );
};
